<div>
  <div fxLayout="row" fxLayoutAlign="end center" style="padding: 10px 20px 0px 20px;">
    <button [mat-dialog-close]="true" class="close-button"
            color="primary"
            mat-raised-button
            type="button">
      Fermer
    </button>
  </div>

  <app-reponse-fiche *ngIf="response"
                     [response]="response"
                     [displayOpenInNewWindow]="true"></app-reponse-fiche>
</div>
